import React from "react";
import { CommonTableUI } from "../TableTemplate/common";
import { ITableUI } from "../TableTemplate/tableTemplate";
import { ISahraUserGroupsReport } from "../../Interfaces/sahraUserGroupsInterfaces";
import { SahraUsersGroupTableAdditional } from "./Additional";

interface IProps extends ITableUI<ISahraUserGroupsReport> {
  tableRefreshFlag: boolean;
  setTableRefreshFlag: (flag: boolean) => void;
}

const TableUI: React.FC<IProps> = ({
  reports,
  onAction,
  tableRefreshFlag,
  setTableRefreshFlag,
}) => {

  React.useEffect(() => {
    if (tableRefreshFlag && onAction) {
      setTableRefreshFlag(false);
      onAction();
    }
  }, [tableRefreshFlag, onAction, setTableRefreshFlag]);

  return (
    <CommonTableUI
      reports={reports}
      onAction={onAction}
      AdditionalBody={SahraUsersGroupTableAdditional}
      tableBoxClassName="max-h-[calc(100dvh-230px)] overflow-y-auto"
    />
  );
};

export default TableUI;
